import { buildConnectionRows, ConnectionRow } from './connection-rows';
import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ApService } from 'src/app/shared/services/ap.service';

@Component({
  selector: 'app-device-data-usage',
  templateUrl: './device-data-usage.component.html',
  styleUrls: ['./device-data-usage.component.scss']
})
export class DeviceDataUsageComponent implements OnInit {
  vHub_mode: any;
  dpcData: {}[];
  links: any = [];
  timelineSummary: any;
  @Input() set dataUsage(obj) {
    if (obj) {
      this.LastHistData = obj.LastHistData;
      this.histdata = obj.histdata;
      this.timelineSummary = obj.timelineSummary;
    }
  }
  @Input() model;
  public connectionRows: ConnectionRow[] = [];
  @Input() set device(obj) {
    const device = obj && obj[0];
    const statistics = device?.statistics || {};
    this.vHub_mode = device?.templateConfig?.team?.config?.team1?.mode === 'VHUB';
    this.is_oldfirmware = !statistics.teams && !statistics.interfaces;
    this.connectionRows = buildConnectionRows(statistics);
  }
  @Output() edit = new EventEmitter();


  public teams = [];
  public bridges_lan: any;
  public bridges_lan2: any;
  public bridges_lan3: any;
  public bridges_guest: any;
  public wifi_2g_ap: any;
  public wifi_2g_guest: any;
  public wifi_5g_ap: any;
  public wifi_5g_guest: any;
  public foutglte: any;
  public is_oldfirmware = true;
  public LastHistData: any;
  public histdata: any = [];
  private availableLinks = {};

  constructor(
    private cdr: ChangeDetectorRef,
    private apService: ApService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }
  modifyIFname(bridge){
    if(bridge && bridge.ifname){
      let res = bridge.ifname.split("-");
      bridge.ifname = res[1]
      return bridge
    }      
  }
  sum(data) {
    let s = 0;
    data.forEach(element => {
      s += element
    });
    return s;

  }

  get rows(): ConnectionRow[] {
    if (!this.is_oldfirmware || this.connectionRows.length) { return this.connectionRows; }
    const large = this.model === 'RRT-500';
    const links = [
      { link: 'link1', ifname: large ? 'eth2' : 'eth0.2', interface: 'wan' },
      { link: 'link2', ifname: large ? 'eth3' : 'eth0.3', interface: 'wan2' },
      { link: 'link3', ifname: 'wg1', interface: 'wg1' }
    ];
    if (['RRT-200', 'RRT-500'].includes(this.model) && this.getData('wwan0') !== '0 Bytes') {
      links.push({ link: 'link2', ifname: 'wwan0', interface: '4GLTE' });
    }
    return buildConnectionRows({ teams: { team1: { links: links.map(link => ({ ...link,
      type: this.getKey(link.link + ' type'), action: this.getKey(link.link + ' action'),
      state: this.getKey(link.link + ' state')
    })) } }, ...(!this.vHub_mode ? {
      bridges: { lan: { ifname: 'br-lan' } },
      wifi: { '2g_ap': { ifname: 'wlan0' }, '5g_ap': { ifname: 'wlan1' } }
    } : {}) });
  }

  private usageBytes(row: ConnectionRow): number | null {
    if (this.hasCumulativeUsage) { return row.cumulativeBytes == null ? null : row.cumulativeBytes; }
    if (row.disabled) { return 0; }
    const samples = this.timelineSummary ? [this.timelineSummary] : this.histdata || [];
    let found = false;
    const total = samples.reduce((sum, sample) => {
      const key = row.usageKeys.find(candidate => sample[candidate] != null);
      if (!key) { return sum; }
      found = true;
      return sum + Math.max(0, Number(sample[key]) || 0);
    }, 0);
    return found ? total : null;
  }

  usage(row: ConnectionRow): string {
    const bytes = this.usageBytes(row);
    if (this.hasCumulativeUsage) {
      return bytes == null || (row.type === 'RAS' && bytes === 0) ? '' : this.formatBytes(bytes, 1024, 1);
    }
    return bytes == null ? (row.detail ? '' : '0 Bytes') : this.formatBytes(bytes, row.device === 'wwan0' ? 1000 : 1024);
  }

  total() {
    const seen = new Set<string>();
    const bytes = this.rows.reduce((sum, row) => {
      // Transport/lane usage is a breakdown of its parent, not additional traffic.
      const key = row.device || row.usageKeys.join('|');
      if (row.detail || seen.has(key)) { return sum; }
      seen.add(key);
      return sum + (this.usageBytes(row) || 0);
    }, 0);
    return this.formatBytes(bytes, 1024, this.hasCumulativeUsage ? 1 : 2);
  }
  get hasCumulativeUsage(): boolean {
    return this.connectionRows.some(row => row.cumulativeBytes != null);
  }
  formatBytes(bytes, k=0, decimals = 2) {
    bytes = Number(bytes);
    if (bytes === 0) return '0 Bytes';

    k = k == 0? 1024: k;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    if (parseFloat((bytes / Math.pow(k, i)).toFixed(dm))) {
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  }

  getData(label) {
    if (this.timelineSummary && this.timelineSummary[label + " Transferred"] !== undefined) {
      const sum = Number(this.timelineSummary[label + " Transferred"]) || 0;
      if(label == "wwan0"){
        return this.formatBytes(sum, 1000)
      }
      return this.formatBytes(sum)
    }
    let sum = 0;
    this.histdata.forEach(element => {
      if (element[label + " Transferred"]) {
        return sum += (Number(element[label + " Transferred"] > 0) ? Number(element[label + " Transferred"]): 0)
      }
    });
    if(label == "wwan0"){
      return this.formatBytes(sum, 1000)
    }
    return this.formatBytes(sum)
  }

  getDataLink(label, link) {
    if (this.timelineSummary) {
      const timelineLinkValue = this.timelineSummary[link + " " + label + " Transferred"];
      const timelineLabelValue = this.timelineSummary[label + " Transferred"];
      const sum = Number(timelineLinkValue ?? timelineLabelValue) || 0;
      if(label == "wwan0"){
        return this.formatBytes(sum, 1000)
      }
      return this.formatBytes(sum)
    }
    let sum = 0;
    this.histdata.forEach(element => {
      if(element[link + " " + label + " Transferred"]){
        return sum += (Number(element[label + " Transferred"] > 0) ? Number(element[label + " Transferred"]): (Number(element[link + " " + label + " Transferred"] > 0) ? Number(element[link + " " + label + " Transferred"]): 0))
      } else if (element[label + " Transferred"]) {
        return sum += (Number(element[label + " Transferred"] > 0) ? Number(element[label + " Transferred"]): 0)
      }
    });
    if(label == "wwan0"){
      return this.formatBytes(sum, 1000)
    }
    return this.formatBytes(sum)
  }

  getDPC(label) {
    if (label && label.indexOf("wg") !== -1) {
      let bwCount = Number(label.replace(/[^0-9]/g, ""));
      return `wg${bwCount} (DPC${bwCount})`
    } else {
      return null
    }
  }

  getKey(label) {
    if (this.LastHistData) {
      for (let i = 0; i < Object.keys(this.LastHistData).length; i++) {
        let key = Object.keys(this.LastHistData)[i];
        if (key.indexOf(label) > -1) {
          let str = key.split(label)[1]
          return str.replace(" (", "").replace(")", "");
        }
      }
    }
  }

  editDevice() {
    this.edit.emit();
  }
}
